var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryIconBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_5529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 4H3C2.45 4 2 4.45 2 5V18.25C2 20.88 4.14 23.03 6.78 23.03H21.23C23.86 23.03 26.01 20.89 26.01 18.25V5C26.01 4.45 25.56 4 25.01 4H25ZM24 6V8.67H4V6H24ZM21.22 21.03H6.78C5.25 21.03 4 19.78 4 18.25V12H24V18.25C24 19.78 22.75 21.03 21.22 21.03Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.41 14.33H6.56C6.01 14.33 5.56 14.78 5.56 15.33C5.56 15.88 6.01 16.33 6.56 16.33H16.41C16.96 16.33 17.41 15.88 17.41 15.33C17.41 14.78 16.96 14.33 16.41 14.33Z",
    fill: "#82BCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_5529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.03,
    fill: "white",
    transform: "translate(2 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryIconBank);
export default __webpack_public_path__ + "static/media/entry_icon_bank.6ef951a276e69ba996c7c47ebcaaa236.svg";
export { ForwardRef as ReactComponent };